import { useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatApiError, uploadFile } from "@/lib/api";
import { CATEGORIES } from "@/lib/constants";

export const UploadReelDialog = () => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Choose a video file");
    setProgress(0);
    try {
      const video = await uploadFile(file, setProgress);
      await api.post("/posts", { type: "video", text, video, category, images: [] });
      toast.success("Video submitted. It will go live after admin approval.");
      setOpen(false); setText(""); setFile(null);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setProgress(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button className="rounded-full bg-tm-green hover:bg-tm-green/90" data-testid="reels-upload-video-button"><Upload className="mr-2 h-4 w-4" />Upload video</Button></DialogTrigger>
      <DialogContent data-testid="reels-upload-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-tm-green">Upload a video</DialogTitle>
          <DialogDescription>Videos are reviewed by the Taxmandi team before they appear in Reels.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2"><Label>Video file</Label><Input type="file" accept="video/*" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="reel-file-input" /></div>
          <div className="space-y-2"><Label>Caption</Label><Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} data-testid="reel-caption-input" /></div>
          <div className="space-y-2"><Label>Category</Label>
            <Select value={category} onValueChange={setCategory}>
              <SelectTrigger data-testid="reel-category-select"><SelectValue /></SelectTrigger>
              <SelectContent>{CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
            </Select></div>
          <Button type="submit" disabled={progress !== null} className="w-full rounded-full bg-tm-green hover:bg-tm-green/90" data-testid="reel-submit-button">
            {progress !== null ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Uploading {progress}%</> : "Submit video"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
